var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShieldAlt3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 6.2578C3 5.57151 3.55355 5.01517 4.23638 5.01517H4.81625C5.84816 5.01517 6.79151 4.4292 7.253 3.50156L7.44721 3.11116C7.786 2.43017 8.47852 2 9.23607 2H14.7639C15.5215 2 16.214 2.43017 16.5528 3.11116L16.747 3.50156C17.2085 4.4292 18.1518 5.01517 19.1838 5.01517H19.7636C20.4465 5.01517 21 5.57151 21 6.2578V9.41707C21 14.9433 17.6245 19.9028 12.4999 21.9057C12.1784 22.0314 11.8216 22.0314 11.5001 21.9057C6.37552 19.9028 3 14.9433 3 9.41707V6.2578Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldAlt3);
export default __webpack_public_path__ + "static/media/shield-alt-3.a2c72ebbfb5d0a10754a39d164574f4d.svg";
export { ForwardRef as ReactComponent };